import axios from 'axios';
import jwtDecode from 'jwt-decode';
import TokenService from './token.service';
import {API_URL} from '../parameters';
import {router} from "../router";

const instance = axios.create({
    baseURL: API_URL + '/accounts/',
    timeout: 5000,
});

class AuthService {
    async init() {
        const response = await instance.get('authenticate/france_connect/url/');
        return response.data.url;
    }

    async identification(code, state) {
        const response = await instance.post('authenticate/france_connect/auth/', { 'code': code, 'state': state },
            { timeout: 4000 });
        TokenService.setIdToken(response.data.id_token);
        return jwtDecode(response.data.id_token);
    }

    async magic_token(data) {
        const response = await instance.post('authenticate/magic_token/auth/', data);
        TokenService.setIdToken(response.data.id_token);
        TokenService.setAccessToken(response.data.access_token);
        TokenService.setRefreshToken(response.data.refresh_token);
        return response.data;
    }

    async form(data) {
        const response = await instance.post('authenticate/form/auth/', data);
        TokenService.setIdToken(response.data.id_token);
        TokenService.setAccessToken(response.data.access_token);
        return response.data;
    }
    async getUser(id) {
        const response = await instance.get('users/' + id, { headers: TokenService.idHeader() });
        return response.data;
    }
    async updatePasswordUser(id, data) {
        const response = await instance.patch('users/'+ id, data, { headers: TokenService.idHeader() });
        return response.data;
    }
    async authentication(ipp) {
        const response = await instance.post('authenticate/login/ipp/', {'ipp': ipp }, {headers: TokenService.idHeader()});
        TokenService.setAccessToken(response.data.id_token);
        TokenService.setAccessToken(response.data.access_token);
        TokenService.setRefreshToken(response.data.refresh_token);
        return response.data;
    }
    
    getGddiId() {
        if (TokenService.getAccessToken()) {
            return jwtDecode(TokenService.getAccessToken()).gddi_id;
        }
        else if(TokenService.getIdToken()) {
            return jwtDecode(TokenService.getIdToken()).gddi_id;
        }
        return null;
    }

    getUserInfos() {
        if(TokenService.getIdToken()) {
            return jwtDecode(TokenService.getIdToken());
        }
        return {};
    }

    isIdentified() {
        const idToken = TokenService.getIdToken();
        return !!idToken;
    }

    isAuthenticated() {
        const accessToken = TokenService.getAccessToken();
        return !!accessToken && !TokenService.isTokenExpired(accessToken);
    }


    async logout(from_login = false) {
        try {
            const response = await instance.get('authenticate/logout/end_session/', { headers: TokenService.idHeader() });
            if (response.data.url) {
                window.location.href = response.data.url;
            } else {
                if(!from_login){
                    router.push({name: 'Login'});
                }
            }
        } catch (e) {
            console.log(e);
        } finally {
            TokenService.clearIdToken();
            TokenService.clearAccessToken();
            TokenService.clearRefreshToken();
        }
    }

}

export default new AuthService();
